import type { MasterFieldDef } from './masters/types';

function imageField(
  key: string,
  label: string,
  extra?: Partial<MasterFieldDef>,
): MasterFieldDef {
  return {
    key,
    label,
    type: 'image',
    helperText: 'PNG, JPEG, or WebP',
    ...extra,
  };
}

export const foodImageFields = {
  restaurantType: () => imageField('imageUrl', 'Cover Image', { required: true }),
  category: () => imageField('imageUrl', 'Category Image', { required: true }),
  cuisine: () => imageField('imageUrl', 'Cuisine Image', { required: true }),
  addon: () => imageField('imageUrl', 'Addon Image'),
  thumbnail: () => imageField('imageUrl', 'Thumbnail', {
    required: true,
    imageMaxWidth: 1200,
    imageMaxHeight: 800,
    helperText: 'PNG, JPEG, or WebP · max 1200×800px',
  }),
  gallery: () => imageField('imageUrl', 'Gallery Image', {
    required: true,
    imageMaxWidth: 1200,
    imageMaxHeight: 800,
    helperText: 'PNG, JPEG, or WebP · max 1200×800px',
  }),
  dietaryIcon: () => imageField('icon', 'Dietary Icon', {
    imageMaxWidth: 256,
    imageMaxHeight: 256,
    imageAspectRatio: '1:1',
    helperText: 'PNG, JPEG, or WebP · max 256×256px',
  }),
};

export const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
export const PHONE_PATTERN = /^\+?\d{8,15}$/;
